module.exports = __webpack_public_path__ + "static/media/CADEAIHeader.25b28278.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/CADEAIHeader.png
// module id = 142
// module chunks = 0